export const filters = [
    {
        title: 'filters.duotone.title',
        url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e047300d14ccb4ed37941.png',
        options: [
            {
                title: 'filters.duotone.desert',
                customFilter_desert: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the sepia effect
                        const sepiaR = data[i] * 0.393 + data[i + 1] * 0.769 + data[i + 2] * 0.189;
                        const sepiaG = data[i] * 0.349 + data[i + 1] * 0.686 + data[i + 2] * 0.168;
                        const sepiaB = data[i] * 0.272 + data[i + 1] * 0.534 + data[i + 2] * 0.131;
                        // Apply the warm orange tone
                        data[i] = sepiaR + 100; // Adjust as needed
                        data[i + 1] = sepiaG + 50; // Adjust as needed
                        data[i + 2] = sepiaB; // Adjust as needed
                    }
                    return imageData;
                },
                value: 'desert',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cba2ca70077a.jpeg',
            },
            {
                title: 'filters.duotone.peach',
                customFilter_peach: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    const brightnessFactor = 0.9;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Duotone Peach-Blue effect
                        const redChannel = data[i];
                        const greenChannel = data[i + 1];
                        const blueChannel = data[i + 2];
                        // Adjust the RGB channels to create the Peach-Blue effect
                        data[i] = redChannel * 0.9; // Increase the red channel
                        data[i + 1] = greenChannel * 0.9; // Slightly increase the green channel
                        data[i + 2] = blueChannel * 1.5; // Reduce the blue channel (to add blue)
                        // Adjust brightness by modifying all channels
                        data[i] *= brightnessFactor; // Adjust red channel brightness
                        data[i + 1] *= brightnessFactor; // Adjust green channel brightness
                        data[i + 2] *= brightnessFactor; // Adjust blue channel brightness
                    }
                    return imageData;
                },
                value: 'peach',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cb700f70077c.jpeg',
            },
            {
                title: 'filters.duotone.clash',
                customFilter_clash: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Clash effect with pink and red colors
                        data[i] = data[i] * 1.5; // Increase the red channel
                        data[i + 1] = 100; // Set the green channel to a fixed value (e.g., dark gray)
                        data[i + 2] = 200; // Set the blue channel to a fixed value (e.g., pink)
                    }
                    return imageData;
                },
                value: 'clash',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cb4d8d700783.jpeg',
            },
            {
                title: 'filters.duotone.plum',
                customFilter_plum: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    const brightnessFactor = 0.8;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Duotone Plum effect
                        const redChannel = data[i];
                        const greenChannel = data[i + 1];
                        const blueChannel = data[i + 2];
                        // Adjust the RGB channels to create the Plum effect
                        data[i] = redChannel * 0.5; // Increase the red channel
                        data[i + 1] = greenChannel * 0.9; // Decrease the green channel
                        data[i + 2] = blueChannel * 0.9; // Increase the blue channel
                        // Adjust brightness by modifying all channels
                        data[i] *= brightnessFactor; // Adjust red channel brightness
                        data[i + 1] *= brightnessFactor; // Adjust green channel brightness
                        data[i + 2] *= brightnessFactor; // Adjust blue channel brightness
                    }
                    return imageData;
                },
                value: 'plum',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cb5505700778.jpeg',
            },
            {
                title: 'filters.duotone.breezy',
                customFilter_breezy: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Duotone Breezy effect
                        const redChannel = data[i];
                        const greenChannel = data[i + 1];
                        const blueChannel = data[i + 2];
                        // Adjust the RGB channels to create the Breezy effect
                        data[i] = redChannel * 1.2; // Increase the red channel
                        data[i + 1] = greenChannel * 0.8; // Decrease the green channel
                        data[i + 2] = blueChannel * 1.5; // Increase the blue channel
                    }
                    return imageData;
                },
                value: 'breezy',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091351591648dd7199f.jpeg',
            },
            {
                title: 'filters.duotone.deepBlue',
                customFilter_deepBlue: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    const brightnessFactor = 0.9;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Duotone Peach-Blue effect
                        const redChannel = data[i];
                        const greenChannel = data[i + 1];
                        const blueChannel = data[i + 2];
                        // Adjust the RGB channels to create the Peach-Blue effect
                        data[i] = redChannel * 0.7; // Increase the red channel
                        data[i + 1] = greenChannel * 0.7; // Slightly increase the green channel
                        data[i + 2] = blueChannel * 1.9; // Reduce the blue channel (to add blue)
                        // Adjust brightness by modifying all channels
                        data[i] *= brightnessFactor; // Adjust red channel brightness
                        data[i + 1] *= brightnessFactor; // Adjust green channel brightness
                        data[i + 2] *= brightnessFactor; // Adjust blue channel brightness
                    }
                    return imageData;
                },
                value: 'deepBlue',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cb96cd70077e.jpeg',
            },
            {
                title: 'filters.duotone.frog',
                customFilter_frog: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    const brightnessFactor = 1;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Duotone Frog effect
                        const greenChannel = data[i + 1];
                        const blueChannel = data[i + 2];
                        // Adjust the RGB channels to create the Frog effect
                        data[i] = greenChannel * 0.4; // Increase the red channel using green
                        data[i + 1] = blueChannel * 1.3; // Increase the green channel using blue
                        data[i + 2] = greenChannel * 0.7; // Increase the blue channel using green
                        // Adjust brightness by modifying all channels
                        data[i] *= brightnessFactor; // Adjust red channel brightness
                        data[i + 1] *= brightnessFactor; // Adjust green channel brightness
                        data[i + 2] *= brightnessFactor; // Adjust blue channel brightness
                    }
                    return imageData;
                },
                value: 'frog',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cbbe34700784.jpeg',
            },
            {
                title: 'filters.duotone.sunset',
                customFilter_sunset: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Duotone Sunset effect
                        const redChannel = data[i];
                        const greenChannel = data[i + 1];
                        const blueChannel = data[i + 2];
                        // Adjust the RGB channels to create the Sunset effect
                        data[i] = redChannel * 1.5; // Increase the red channel
                        data[i + 1] = greenChannel * 0.7; // Decrease the green channel
                        data[i + 2] = blueChannel * 0.5; // Decrease the blue channel
                    }
                    return imageData;
                },
                value: 'sunset',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/654330911eae18747a441b18.jpeg',
            },
        ],
    },
    {
        title: 'filters.blackAndWhite.title',
        url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e047300d14c742ed37942.png',
        options: [
            {
                title: 'filters.blackAndWhite.greyed',
                customFilter_greyed: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Calculate the grayscale value
                        const gray = (data[i] + data[i + 1] + data[i + 2]) / 3;
                        // Set R, G, and B channels to the grayscale value
                        data[i] = gray;
                        data[i + 1] = gray;
                        data[i + 2] = gray;
                    }
                    return imageData;
                },
                value: 'greyed',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/654330911eae183e5b441b1c.jpeg',
            },
            {
                title: 'filters.blackAndWhite.dusty',
                customFilter_dusty: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Dusty effect (grayscale with a brownish tint)
                        const gray = (data[i] + data[i + 1] + data[i + 2]) / 3;
                        data[i] = gray + 20; // Adjust as needed for the brownish tint
                        data[i + 1] = gray + 10; // Adjust as needed for the brownish tint
                        data[i + 2] = gray + 5; // Adjust as needed for the brownish tint
                    }
                    return imageData;
                },
                value: 'dusty',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/6543309135159150b5d7199c.jpeg',
            },
            {
                title: 'filters.blackAndWhite.litho',
                customFilter_litho: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    const intensity = 0.9;
                    for (let i = 0; i < length; i += 4) {
                        // Convert the pixel to grayscale
                        const grayscale = (data[i] + data[i + 1] + data[i + 2]) / 3;
                        // Apply the Litho effect with adjustable intensity
                        data[i] = (grayscale + 2 * intensity) * (intensity + 0.5); // Red channel
                        data[i + 1] = (grayscale + intensity) * (intensity + 0.7); // Green channel
                        data[i + 2] = (grayscale - intensity) * (intensity + 1.3); // Blue channel
                    }
                    return imageData;
                },
                value: 'litho',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091351591d1c6d719a1.jpeg',
            },
            {
                title: 'filters.blackAndWhite.sepia',
                customFilter_sepia: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Sepia effect
                        const r = data[i];
                        const g = data[i + 1];
                        const b = data[i + 2];
                        data[i] = r * 0.393 + g * 0.769 + b * 0.189;
                        data[i + 1] = r * 0.349 + g * 0.686 + b * 0.168;
                        data[i + 2] = r * 0.272 + g * 0.534 + b * 0.131;
                    }
                    return imageData;
                },
                value: 'sepia',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/654330911eae18ca1a441b1b.jpeg',
            },
            {
                title: 'filters.blackAndWhite.weathered',
                customFilter_weathered: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    const grayIntensity = 0.7;
                    for (let i = 0; i < length; i += 4) {
                        // Convert the pixel to grayscale
                        const grayscale = (data[i] + data[i + 1] + data[i + 2]) / 3;
                        // Apply the Weathered effect with increased gray intensity
                        const weatheredValue = grayscale * grayIntensity;
                        data[i] = weatheredValue; // Red channel
                        data[i + 1] = weatheredValue; // Green channel
                        data[i + 2] = weatheredValue; // Blue channel
                    }
                    return imageData;
                },
                value: 'weathered',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/6543309135159161bdd7199e.jpeg',
            },
        ],
    },
    {
        title: 'filters.vintage.title',
        url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e047300d14c0e13d37940.png',
        options: [
            {
                title: 'filters.vintage.polaroid',
                customFilter_polaroid: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Vintage Polaroid effect
                        const r = data[i];
                        const g = data[i + 1];
                        const b = data[i + 2];
                        // Adjust color values as needed
                        data[i] = r * 0.9 + g * 0.2 + b * 0.1;
                        data[i + 1] = r * 0.2 + g * 0.9 + b * 0.1;
                        data[i + 2] = r * 0.1 + g * 0.1 + b * 0.9;
                    }
                    return imageData;
                },
                value: 'polaroid',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cb2059700777.jpeg',
            },
            {
                title: 'filters.vintage.sunny',
                customFilter_sunny: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Sunny effect (elevate brightness and add warmth)
                        data[i] = data[i] * 1.1; // Adjust as needed for brightness
                        data[i + 1] = data[i + 1] * 1.1; // Adjust as needed for brightness
                        data[i + 2] = data[i + 2] * 1.2; // Adjust as needed for warmth
                    }
                    return imageData;
                },
                value: 'sunny',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cb1036700782.jpeg',
            },
            {
                title: 'filters.vintage.oldTimer',
                customFilter_oldTimer: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Old-Timer effect (subtle color fading)
                        data[i] = data[i] * 0.9; // Adjust as needed for fading
                        data[i + 1] = data[i + 1] * 0.9; // Adjust as needed for fading
                        data[i + 2] = data[i + 2] * 0.8; // Adjust as needed for fading
                    }
                    return imageData;
                },
                value: 'oldTimer',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/654330911eae18878d441b1a.jpeg',
            },
            // {
            //   title: 'filters.vintage.inferno',
            //   filters: [
            //     { name: FilterNames.VINTAGE, value: true },
            //     { name: FilterNames.POLAROID, value: true },
            //     { name: FilterNames.BRIGHTNESS, value: 0.007697 },
            //   ],
            //   value: 'inferno',
            // },
            {
                title: 'filters.vintage.snappy',
                customFilter_snappy: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Snappy effect (increase contrast and saturation)
                        data[i] = data[i] * 1.2; // Adjust as needed for contrast
                        data[i + 1] = data[i + 1] * 1.2; // Adjust as needed for contrast
                        data[i + 2] = data[i + 2] * 1.4; // Adjust as needed for saturation
                    }
                    return imageData;
                },
                value: 'snappy',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cb52e070077d.jpeg',
            },
        ],
    },
    // {
    //   title: 'filters.smooth.title',
    //   url: 'https://storage.googleapis.com/ghl-test/o6241QsiRwUIJHyjuhos/media/650ebb788069a71037e5b8a3.png',
    //   options: [
    //     {
    //       title: 'filters.smooth.chestnut',
    //       filters: [
    //         { name: FilterNames.BRIGHTNESS, value: -0.047197 },
    //         { name: FilterNames.SATURATION, value: -0.29422 },
    //         { name: FilterNames.VIBRANCE, value: 0.290009 },
    //       ],
    //       value: 'chestnut',
    //     },
    //     {
    //       title: 'filters.smooth.softy',
    //       filters: [{ name: FilterNames.VIBRANCE, value: -0.486349 }],
    //       value: 'softy',
    //     },
    //     {
    //       title: 'filters.smooth.pebble',
    //       filters: [
    //         { name: FilterNames.BRIGHTNESS, value: 0.101801 },
    //         { name: FilterNames.VIBRANCE, value: -0.153064 },
    //       ],
    //       value: 'pebble',
    //     },
    //     {
    //       title: 'filters.smooth.moss',
    //       filters: [
    //         { name: FilterNames.BRIGHTNESS, value: 0.007697 },
    //         { name: FilterNames.VIBRANCE, value: 0.395876 },
    //       ],
    //       value: 'moss',
    //     },
    //     {
    //       title: 'filters.smooth.lemon',
    //       filters: [
    //         { name: FilterNames.BRIGHTNESS, value: 0.09788 },
    //         { name: FilterNames.SATURATION, value: -0.364798 },
    //         { name: FilterNames.VIBRANCE, value: 0.45077 },
    //         { name: FilterNames.HUE, value: -0.056 },
    //       ],
    //       value: 'lemon',
    //     },
    //     {
    //       title: 'filters.smooth.greenGap',
    //       filters: [
    //         { name: FilterNames.BRIGHTNESS, value: -0.082486 },
    //         { name: FilterNames.SATURATION, value: -0.223642 },
    //         { name: FilterNames.VIBRANCE, value: -0.011908 },
    //       ],
    //       value: 'greenGap',
    //     },
    //   ],
    // },
    {
        title: 'filters.cold.title',
        url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e04736c5e78a6ab150ef8.png',
        options: [
            {
                title: 'filters.cold.colla',
                customFilter_colla: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Colla effect (elevate blue and desaturate)
                        data[i] = data[i] * 1.2; // Adjust as needed for blue
                        data[i + 1] = data[i + 1] * 0.9; // Desaturate
                        data[i + 2] = data[i + 2] * 0.9; // Desaturate
                    }
                    return imageData;
                },
                value: 'colla',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/654330911eae18fd6d441b19.jpeg',
            },
            {
                title: 'filters.cold.solanus',
                customFilter_solanus: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Solanus effect (elevate blue and green tones)
                        data[i] = data[i] * 1.2; // Adjust as needed for blue
                        data[i + 1] = data[i + 1] * 1.2; // Adjust as needed for green
                    }
                    return imageData;
                },
                value: 'solanus',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cb7f3d70077f.jpeg',
            },
            {
                title: 'filters.cold.kalmen',
                customFilter_kalmen: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Cold Kalmen effect (add a cool, bluish tint)
                        data[i] = data[i] * 0.8; // Adjust as needed for blue tint
                        data[i + 1] = data[i + 1] * 0.9; // Adjust as needed for coolness
                        data[i + 2] = data[i + 2] * 1.2; // Adjust as needed for bluish tint
                    }
                    return imageData;
                },
                value: 'kalmen',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cbcec7700781.jpeg',
            },
            {
                title: 'filters.cold.jorah',
                customFilter_jorah: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Cold Joran effect (cool and distinct color effect)
                        data[i] = data[i] * 0.7; // Adjust as needed for coolness
                        data[i + 1] = data[i + 1] * 0.8; // Adjust as needed for distinct colors
                        data[i + 2] = data[i + 2] * 1.1; // Adjust as needed for bluish tint
                    }
                    return imageData;
                },
                value: 'jorah',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091351591b1aed7199d.jpeg',
            },
            {
                title: 'filters.cold.levante',
                customFilter_levante: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Cold Levante effect (cool and airy with a hint of blue)
                        data[i] = data[i] * 0.9; // Adjust as needed for coolness
                        data[i + 1] = data[i + 1] * 0.9; // Adjust as needed for coolness
                        data[i + 2] = data[i + 2] * 1.1; // Adjust as needed for bluish tint
                    }
                    return imageData;
                },
                value: 'levante',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cbf0ad700776.jpeg',
            },
            {
                title: 'filters.cold.zephyr',
                customFilter_zephyr: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Cold Zephyr effect
                        const redChannel = data[i];
                        const greenChannel = data[i + 1];
                        const blueChannel = data[i + 2];
                        // Adjust the RGB channels to create the Cold Zephyr effect
                        data[i] = redChannel * 0.9; // Reduce the red channel
                        data[i + 1] = greenChannel * 0.9; // Reduce the green channel
                        data[i + 2] = blueChannel * 1.5; // Increase the blue channel
                    }
                    return imageData;
                },
                value: 'zephyr',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cb1c3a70077b.jpeg',
            },
        ],
    },
    {
        title: 'filters.warm.title',
        url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e047300d14c747ad37943.png',
        options: [
            {
                title: 'filters.warm.golden',
                customFilter_golden: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Warm Golden effect (elevate red and yellow tones)
                        data[i] = data[i] * 1.2; // Adjust as needed for red
                        data[i + 1] = data[i + 1] * 1.2; // Adjust as needed for yellow
                    }
                    return imageData;
                },
                value: 'golden',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/654330911eae18ed82441b1d.jpeg',
            },
            {
                title: 'filters.warm.lowFire',
                customFilter_lowFire: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Low Fire effect (enhance red and orange tones)
                        data[i] = data[i] * 1.2; // Adjust as needed for red
                        data[i + 1] = data[i + 1] * 1.1; // Adjust as needed for orange
                    }
                    return imageData;
                },
                value: 'lowFire',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cbb079700780.jpeg',
            },
            {
                title: 'filters.warm.sunrise',
                customFilter_sunrise: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Warm Sunrise effect (enhance warm colors and brightness)
                        data[i] = data[i] * 1.2; // Adjust as needed for enhancing red or orange
                        data[i + 1] = data[i + 1] * 1.1; // Adjust as needed for enhancing yellow or orange
                        data[i + 2] = data[i + 2] * 1.1; // Adjust as needed for enhancing yellow or orange
                    }
                    return imageData;
                },
                value: 'sunrise',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/65433091de92cb3dbc700779.jpeg',
            },
            {
                title: 'filters.warm.flatBack',
                customFilter_flatBack: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Warm Flatback effect (enhance warmth and adjust colors)
                        data[i] = data[i] * 1.1; // Adjust as needed for warmth
                        data[i + 1] = data[i + 1] * 1.05; // Adjust as needed for color enhancement
                        data[i + 2] = data[i + 2] * 1.05; // Adjust as needed for color enhancement
                    }
                    return imageData;
                },
                value: 'flatBack',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/654330913515913357d719a0.jpeg',
            },
            {
                title: 'filters.warm.pumpkin',
                customFilter_pumpkin: imageData => {
                    const data = imageData.data;
                    const length = data.length;
                    for (let i = 0; i < length; i += 4) {
                        // Apply the Warm Pumpkin effect (enhance red and orange tones)
                        data[i] = data[i] * 1.2; // Adjust as needed for red
                        data[i + 1] = data[i + 1] * 1.1; // Adjust as needed for orange
                        data[i + 2] = data[i + 2] * 0.9; // Adjust as needed for desaturation
                    }
                    return imageData;
                },
                value: 'pumpkin',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/654330911eae1818cf441b1e.jpeg',
            },
        ],
    },
];
